module.exports = __webpack_public_path__ + "assets/img/left-submit-zh.8607b001.png";